export default __webpack_public_path__ + "static/media/cpr7.d67b0aa4.jpg";